export const requiredFilterPath = [
    "company.min_ctc",
    "company.max_ctc",
    "company.notice_period",
    "company.any", // any include company
    "company.exclude", // all exclude company
    "company.designation_categories",
    "company.designations",
    "education_insight",
    "personal_insight",
    "experience_insight",
    "work_experience_insights",
    "show_only_contactable_profiles",
    "additional.gender",
    "additional.disability_type",
    "additional.show_only_verified_email",
    "additional.show_only_verified_mobile",
    "additional.show_resumes_not_viewed",
    "additional.age_from",
    "additional.age_to",
    "education", // entire education block
    "location", // entire location block
    "experience",
    "industry",
    "nationality",
    "refine_search.exclude_downloaded",
    "refine_search.exclude_email_sent",
    "refine_search.exclude_sms_sent",
    "queries.all",
    "queries.boolean",
    "queries.combined",
    "queries.exclude",
    "queries.any",
  ];